/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from './headerfooter/header.component.ngfactory';
import * as i4 from '../../../src/app/headerfooter/header.component';
import * as i5 from '@angular/router';
import * as i6 from '../../../src/app/user/user.service';
import * as i7 from '../../../src/app/headerfooter/header.service';
import * as i8 from '../../../src/app/trial/trial.service';
import * as i9 from '../../../src/app/main/config/config.service';
import * as i10 from '../../../src/app/systeminformation/systeminformation.service';
import * as i11 from '../../../src/app/app.component';
import * as i12 from '../../../src/app/publisher/publisher.service';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
function View_AppComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'div',[['class',
      'header-area']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(278528,(null as any),0,i2.NgStyle,[i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer],{ngStyle:[0,'ngStyle']},(null as any)),i1.ɵpod({display:0}),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'header',([] as any[]),(null as any),(null as any),(null as any),
          i3.View_HeaderComponent_0,i3.RenderType_HeaderComponent)),i1.ɵdid(114688,
          (null as any),0,i4.HeaderComponent,[i5.Router,i5.ActivatedRoute,i6.UserService,
              i7.HeaderService,i8.TrialService,i9.ConfigService,i10.SystemInformationService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['\n    ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _ck(_v,2,0,(((_co.currentRoute === '/trial') || (_co.currentRoute === '/release-notes'))? 'none': 'block'));
        _ck(_v,1,0,currVal_0);
        _ck(_v,5,0);
      },(null as any));
}
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),10,'div',[['class',
      'app']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i11.AppComponent = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.onClicked()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AppComponent_1)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),4,'div',[['class','mainarea']],(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(16777216,(null as any),(null as any),1,
          'router-outlet',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(212992,(null as any),0,i5.RouterOutlet,
          [i5.ChildrenOutletContexts,i1.ViewContainerRef,i1.ComponentFactoryResolver,
              [8,(null as any)],i1.ChangeDetectorRef],(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        var _co:i11.AppComponent = _v.component;
        const currVal_0:any = _co.isLoggedIn();
        _ck(_v,3,0,currVal_0);
        _ck(_v,8,0);
      },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(114688,(null as any),0,i11.AppComponent,[i6.UserService,i12.PublisherService,
          i5.Router,i5.ActivatedRoute],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i11.AppComponent> = i1.ɵccf('app',
    i11.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cyIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImFwcFwiIChjbGljayk9XCJvbkNsaWNrZWQoKVwiPlxuICAgIDxkaXYgY2xhc3M9XCJoZWFkZXItYXJlYVwiICpuZ0lmPVwiaXNMb2dnZWRJbigpXCIgW25nU3R5bGVdPVwie2Rpc3BsYXk6IChjdXJyZW50Um91dGUgPT09ICcvdHJpYWwnIHx8IGN1cnJlbnRSb3V0ZSA9PT0gJy9yZWxlYXNlLW5vdGVzJykgPyAnbm9uZScgOiAnYmxvY2snfVwiPlxuICAgICAgICA8aGVhZGVyPjwvaGVhZGVyPlxuICAgIDwvZGl2PlxuICAgIDxkaXYgY2xhc3M9XCJtYWluYXJlYVwiPlxuICAgICAgICA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG4gICAgPC9kaXY+XG48L2Rpdj4iLCI8YXBwPjwvYXBwPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQ0k7TUFBQTthQUFBO3FCQUFBLGdEQUE4QztNQUEyRywrQ0FDcko7VUFBQTtpRUFBQSxVQUFBO1VBQUE7NEZBQUE7VUFBQSw2QkFBaUI7OztRQUR5QjtRQUE5QyxXQUE4QyxTQUE5QztRQUNJOzs7O29CQUZSO01BQUE7SUFBQTtJQUFBO0lBQWlCO01BQUE7TUFBQTtJQUFBO0lBQWpCO0VBQUEsZ0NBQXVDLDJDQUNuQzthQUFBO2FBQUE7VUFBQSx3QkFFTSwyQ0FDTjtpQkFBQTtjQUFBLDBEQUFzQjtVQUFBLGlCQUNsQjtVQUFBO1VBQUEscUNBQUE7VUFBQTtjQUFBO01BQStCLDJDQUM3Qjs7O1FBTG1CO1FBQXpCLFdBQXlCLFNBQXpCO1FBSUk7Ozs7b0JDTFI7TUFBQTthQUFBO3FDQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./aot_output/src/app/app.component.ngfactory.ts